import React, {useEffect, useReducer, useState} from 'react';
import {Link} from "react-router-dom";

import useGoogleCaptcha from '../../components/useReCaptcha.js';
import FlashMessages from '../../components/flashMessages.js';

import {ContactUsPageResult} from '../../../../server/routes/contact-us.js'

interface ContactusProps {
	server: string;
	pageData: unknown;
}

interface ContactUsFormProps {
	reCaptchaSiteKey?: string;
	props: ContactUsPageResult;
	google?: wts_approved_any;
}

interface ErrorState {
	title: string;
	description: string;
	active: boolean;
}

interface ContactFormState {
	error: ErrorState;
}

interface ContactResponse {
	success?: boolean;
	errors?: { msg: string }[];
}

interface FormElements extends HTMLFormControlsCollection {
	fullname: HTMLInputElement;
	company: HTMLInputElement;
	email: HTMLInputElement;
	message: HTMLTextAreaElement;
}

interface ContactForm extends HTMLFormElement {
	readonly elements: FormElements;
}

declare const grecaptcha: {
	getResponse(): string;
	reset(): void;
};

export default function Contactus({server, pageData}: ContactusProps) {

	const [data, setData] = useState(pageData as ContactUsPageResult);
    const google = useGoogleCaptcha();

	return (
        <>     
        <div  className={ "app" }>
             <section className="section section-lg reports-body">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h3 className="text-left mb-3">
                                <b>
                                    Send us a message
                                </b>
                            </h3>
                        </div>
                    </div>    
                    <div className="row row-50">
                  
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <ContactUsForm      
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey}
                                google={google}
                            />         
                        </div>
                        <div className="col-md-1 col-lg-1 col-xl-1">
                        </div>
                        <div className="col-md-3 col-lg-3 col-xl-3">
                            <ContactInfo /> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </div>
 
        </>
    )
}

type ContactUsFormAction = 
	| ["error", { title?: string; description?: string; active?: boolean }]
	| ["success", { title?: string; description?: string; active?: boolean }];

const ContactUsFormReducer = function( state: ContactFormState, [ type, data ]: ContactUsFormAction ): ContactFormState {
    if( type === "error" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};   
    if( type === "success" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};
    return state; 
};

function ContactUsForm({reCaptchaSiteKey, props, google}: ContactUsFormProps) {
	const [ state, dispatch ] = useReducer( ContactUsFormReducer, {
        error: { title: "", description: "", active: false }
      
    });
  
    useEffect(() => { 
		return () => {
			const script: HTMLScriptElement | null = document.getElementById('googleCaptchaScript') as HTMLScriptElement;
			if (script) {
				script.remove();
			}
		}				
	},[google])   

    function SendMessage ( fullname: string, company: string, email: string, captcha: string, message: string): void {
        const requestBody: string = JSON.stringify({
            fullname,
            company,
            email,
            captcha,
            message
            });
    
        fetch( "/contact-us/sendmessage", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then(( result: Response ) => {
            return result.json();
        }).then(( data: ContactResponse ) => {
            if (data.success) { 
                console.log(JSON.stringify(data));
                dispatch([ "success", {
                    title: "Message was sent",
                    description: "Thank you for your message"
                }]);  
            } else {
                console.log(JSON.stringify(data));
                let msg: string = "Unknown error"
                if (data.errors && data.errors.length > 0)
                {
                    msg = data.errors[0].msg
                }
                dispatch([ "error", {
                    title: "Failed to send a message",
                    description: msg
                }]);  
            }
            grecaptcha.reset();
    
        }).catch(( e: Error ) => {
            console.error( "Exception", e );
        });
    
    };   
    function handleSubmit(event: React.FormEvent<ContactForm>): void {
        event.preventDefault()
        const captcha: string = grecaptcha.getResponse();
        SendMessage(
            event.currentTarget.elements.fullname.value,
            event.currentTarget.elements.company.value,
            event.currentTarget.elements.email.value,
            captcha,
            event.currentTarget.elements.message.value)
      }
    return (      
        <>
        <div className={ "error" + (state.error.active ? " " : " hidden") }>
            <div className={ "error-close" } onClick={() => dispatch([ "error", { active: false } ]) }>X</div>
            <div className={ "error-title" }>{ state.error.title }</div>
            <div className={ "error-description" }>{ state.error.description }</div>
        </div>           
        <form action="/contact-us" method="POST" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={props} />
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="fullname"
                    name="fullname"
                    className="form-control"
                    aria-label="Name"
                    placeholder="Your Full Name"
                    required
                />                
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="company"
                    name="company"
                    className="form-control"
                    aria-label="Company"
                    placeholder="Company"
                />                
            </div>
            <div className="form-group">
            <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    aria-label="Email"
                    placeholder="Enter Email"
                    required
                />                
            </div>
            <div className="form-group">
            <textarea
                    id="message"
                    name="message"
                    className="form-control"
                    aria-label="message"
                    placeholder="Comment / Question"
                    rows={4} cols={50}
                    required
                />                
            </div>
            <div className="form-group" style={{ display: "flex" }}>
                            <div style={{ marginLeft: 'auto'}}
                                className="g-recaptcha" 
                                id="captcha1"
                                data-sitekey={reCaptchaSiteKey}>
                            </div>
            </div>           
            <div className="form-group" style={{ display: "flex" }}>
             <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Submit</button>
            </div>
        </form>
    </>
   )
}

function ContactInfo() {

    return (      
        <>
            <h4>Contact us by email</h4>
            <ul>
                <li>
                    <i title = "Email" className="fab fa-envelope" style={{color:'dark-blue'}}> </i> 
                    <a 
								className="link-hover" 
								title={`Our email`} 
								href={`mailto:contact@webtechsurvey.com`}
					><b>contact</b><b>@</b><b>webtechsurvey.com</b>
                    </a>
                </li>

               
            </ul>
        </>
   
   )
}




